import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AlertComponent } from './alert.component';

@NgModule({
  bootstrap: [AlertComponent],
  declarations: [AlertComponent],
  exports: [AlertComponent],
  imports: [BrowserModule],
})
export class AlertModule {}
